import { createUser as mutation } from "../../../lib/graphql";
import { closeHeaderModal } from "../../../actions/siteadmin/modalActions";
import { loadAccount } from "../../../actions/user/account";
import { setRuntimeVariable } from '../../../actions/runtime';
import showToaster from "../../../helpers/toastrMessgaes/showToaster";
import { setLoaderStart, setLoaderComplete } from "../../../actions/loader/loader";
import axios from "axios";
import { getDeviceId } from "../../../core/firebase/firebase";
import history from "../../../history";

import { setCookies } from "../../../helpers/Cookies/cookies";

async function submit(values, dispatch) {
    try {
        if (!navigator.onLine) {
            showToaster({ messageId: 'networkFailed', toasterType: 'error' })
            return;
        }
        const deviceId = await getDeviceId();

        dispatch(setLoaderStart('registerLoading'));
        const params = {
            firstName: values?.firstName.trim(),
            lastName: values?.lastName.trim(),
            email: values?.email,
            phoneDialCode: values?.phoneDialCode,
            phoneNumber: values?.phoneNumber,
            phoneCountryCode: values?.phoneCountryCode,
            lat: values?.lat,
            lng: values?.lng,
            city: values?.city,
            state: values?.state,
            zipcode: values?.zipcode,
            country: values?.country,
            userType: values?.userType,
            preferredLanguage: values?.preferredLanguage,
            address: values?.address,
            preferredLat: values?.preferredLat,
            preferredLng: values?.preferredLng,
            preferredLocation: values?.preferredLocation,
            userType: 1,
            deviceId
        };
        const response = await axios.post('/graphql', {
            query: mutation,
            variables: params
        }, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })

        const { data } = await response?.data;
        if (data?.createUser?.status == 200) {
            setCookies({
                name: 'id_token',
                value: data?.createUser?.result?.token,
                options: { path: '/', maxAge: 1000 * data?.createUser?.result?.expiresIn }
            });
            await dispatch(loadAccount());
            await dispatch(setRuntimeVariable({
                name: 'isAuthenticated',
                value: true,
            }));
            dispatch(closeHeaderModal('registerForm'));
            dispatch(closeHeaderModal('loginModal'));
            dispatch(closeHeaderModal('verifyPhoneNumber'));
            dispatch(setLoaderComplete('registerLoading'));
            history.push(values?.referUrl ? values?.referUrl : '/dashboard');
        } else {
            dispatch(setLoaderComplete('registerLoading'));
            let errorMessage = data?.createUser?.errorMessage
            showToaster({ messageId: 'errorMessage', requestContent: errorMessage, toasterType: 'error' });
        }
    } catch (error) {
        return false;
    }
}

export default submit;